<script setup>

import dayjs from 'dayjs'
import { ref } from 'vue'

import { getI18n } from '@/plugins/i18n'
import { useNotify } from '@/composables/notify'
import { useWebSiteStore } from '@/stores/web-site.store'
import { useScheduleStore } from '@/stores/schedule.store'
import { useNavigator } from '@/composables/navigator'
import { useDetectDevice } from '@/composables/device'

import NavigateBack from '@/components/shared/NavigateBack.vue'
import InputDateSelector from '@/components/shared/InputDateSelector.vue'
import TimeSelector from '@/components/shared/TimeSelector.vue'

const i18n = getI18n()
const scheduleStore = useScheduleStore()
const webSiteStore = useWebSiteStore()

const { notifySuccess } = useNotify()
const { isMobile } = useDetectDevice()

const props = defineProps({
  modelValue: {
    type: [Object, null],
    required: true,
  },
})

const emit = defineEmits(['update', 'cancel'])
useNavigator(() => emit('cancel'))
const editItem = ref(props.modelValue)

if (!editItem.value || !editItem.value.start || !editItem.value.end) {
  editItem.value = {
    start: dayjs().toISOString(),
    end: dayjs().add(2, 'hour').toISOString(),
    service: webSiteStore.user.service_id
  }
}

const onAppointmentInserted = async() => {
  await scheduleStore.upsertEventAsync(editItem.value)
  notifySuccess(i18n.t('info.updatedSuccessfully'))
  emit('update', editItem.value)
}
</script>
<template>
  <q-card class="dialog-card-flex">
    <navigate-back
      :text="editItem?.id ? i18n.t('common.updateVacation') : i18n.t('common.createVacation')"
      @cancel="emit('cancel')"
    />
    <q-card-section v-if="editItem" class="scroll col q-pa-md">
      <div class="row q-col-gutter-sm">
        <input-date-selector
          v-model="editItem"
          :class="isMobile ? 'col-12' : 'col-6'"
          :label="i18n.t('common.startDate')"
        />
        <input-date-selector
          v-model="editItem"
          :class="isMobile ? 'col-12' : 'col-6'"
          :label="i18n.t('common.endDate')"
          :min="editItem.start"
          end
        />
        <time-selector
          v-model="editItem.start"
          :class="isMobile ? 'col-12' : 'col-6'"
          :label="i18n.t('common.startTime')"
          from
          @update:model-value="editItem.end = $event"
        />
        <time-selector
          v-model="editItem.end"
          :class="isMobile ? 'col-12' : 'col-6'"
          :label="i18n.t('common.endTime')"
          :min="editItem.start"
          end
        />
      </div>
    </q-card-section>
    <q-card-actions align="right" class="q-pa-md">
      <q-btn
        color="primary"
        :label="i18n.t('common.confirm')"
        @click="onAppointmentInserted"
      />
    </q-card-actions>
  </q-card>
</template>
